import React, { useState } from 'react';
import DocViewer from './document-viewer';
import PagesPanel from '../pages-panel';
import { Send } from 'lucide-react';
export default function TemplateViewer({
  contract,
  fields,
  setFields,
  onSend,
  users,
}) {
  const data = contract;

  console.log(
    '🚀 ~ file: template-viewer.js:13 ~ TemplateViewer ~ contract:',
    contract,
  );
  const [activePage, setActivePage] = useState('page-1');
  const handleFieldNavigation = (field) => {
    setActivePage(field.pageId);

    setTimeout(() => {
      const target = document.querySelector(`[data-field-id="${field.id}"]`);
      console.log(document.querySelectorAll('[data-field-id]'));

      if (target) {
        document
          .querySelectorAll('.placeholder-active')
          .forEach((el) => el.classList.remove('placeholder-active'));

        target.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });

        target.classList.add('placeholder-active');

        setTimeout(() => {
          target.classList.remove('placeholder-active');
        }, 4000);
      }
    }, 500);
  };
  return (
    <div className="h-screen w-full flex overflow-hidden bg-slate-50 text-slate-800">
      {/* LEFT PAGE PANEL */}
      <aside
        className="
      w-64
      bg-white
      border-r border-slate-200
      overflow-y-auto
      hidden lg:block
      "
      >
        <PagesPanel
          pages={data?.pages}
          activePage={activePage}
          setActivePage={setActivePage}
          isEdit={false}
        />
      </aside>

      {/* CENTER DOCUMENT */}
      <main className="flex-1 flex flex-col min-w-0">
        {/* HEADER */}
        <header
          className="
h-16
bg-white
border-b
border-slate-200
px-6
flex
items-center
justify-between
"
        >
          <div>
            <h1 className="font-semibold text-lg">Contract Review</h1>

            <p className="text-xs text-slate-500">
              Assign placeholders before sending
            </p>
          </div>
        </header>

        {/* DOCUMENT */}
        <section
          className="
        flex-1
        overflow-auto
        bg-gradient-to-br
        from-slate-100
        to-indigo-50
        "
        >
          <DocViewer data={data} activePage={activePage} />
        </section>
        <div className="flex justify-end mb-4 mt-4 mr-4">
          <button
            onClick={onSend}
            className="
flex
items-center
gap-2
px-5
py-2.5
rounded-xl
text-sm
font-semibold
text-white
shadow-lg
hover:scale-105
transition
"
            style={{
              background: '#375AE7',
            }}
          >
            <Send size={17} />
            Send Contract
          </button>
        </div>
      </main>

      {/* ASSIGNMENT PANEL */}
      <aside
        className="
        hidden
xl:flex

      w-[380px]
      bg-white
      border-l
      border-slate-200
      overflow-y-auto
      "
      >
        <AssignmentPanel
          fields={fields}
          setFields={setFields}
          onFieldClick={handleFieldNavigation}
          users={users}
        />{' '}
      </aside>
    </div>
  );
}

function AssignmentPanel({ fields, setFields, onFieldClick, users }) {
  const [filter, setFilter] = useState('all');
  const [search, setSearch] = useState('');
  const [openField, setOpenField] = useState(null);
  const [userSearch, setUserSearch] = useState('');

  const assignedCount = fields.filter((f) => f.assignedUsers?.length).length;

  const pendingCount = fields.length - assignedCount;

  const filteredFields = fields.filter((field) => {
    const matchSearch = field.label
      ?.toLowerCase()
      .includes(search.toLowerCase());

    if (filter === 'assigned')
      return matchSearch && field.assignedUsers?.length;

    if (filter === 'pending')
      return matchSearch && !field.assignedUsers?.length;

    return matchSearch;
  });
  console.log('fields are', fields);
  const assignUser = (fieldId, user) => {
    setFields((prev) =>
      prev.map((field) => {
        if (field.id !== fieldId) {
          return field;
        }

        const currentUsers = field.assignedUsers || [];

        const alreadyAssigned = currentUsers.some(
          (assignedUser) => assignedUser.user_id === user.user_id,
        );

        return {
          ...field,

          assignedUsers: alreadyAssigned
            ? // REMOVE USER
              currentUsers.filter(
                (assignedUser) => assignedUser.user_id !== user.user_id,
              )
            : // ADD USER
              [...currentUsers, user],
        };
      }),
    );
  };

  return (
    <div
      className="
h-full
flex
flex-col
bg-slate-50
"
    >
      {/* HEADER */}

      <div
        className="
sticky
top-0
z-20
bg-white
border-b
p-5
"
      >
        <div
          className="
flex
justify-between
items-center
"
        >
          <div>
            <h2
              className="
text-xl
font-bold
text-slate-800
"
            >
              Field Assignment
            </h2>

            <p
              className="
text-xs
text-slate-500
mt-1
"
            >
              Assign placeholders before sending contract
            </p>
          </div>

          <div
            className="
text-right
"
          >
            <p
              className="
font-bold
text-blue-600
"
            >
              {assignedCount}/{fields.length}
            </p>
          </div>
        </div>

        {/* PROGRESS */}

        <div
          className="
mt-4
h-2
bg-slate-200
rounded-full
overflow-hidden
"
        >
          <div
            style={{
              width: `${(assignedCount / fields.length) * 100}%`,
              background: '#375AE7',
            }}
            className="
h-full
transition-all
"
          ></div>
        </div>

        {/* STATS */}

        <div
          className="
grid
grid-cols-3
gap-3
mt-5
"
        >
          <Stat title="Total" value={fields.length} color="blue" />

          <Stat title="Assigned" value={assignedCount} color="green" />

          <Stat title="Pending" value={pendingCount} color="red" />
        </div>
      </div>

      {/* SEARCH FILTER */}

      <div
        className="
p-4
bg-white
border-b
space-y-3
"
      >
        <input
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="
Search placeholder...
"
          className="
w-full
rounded-xl
border
px-4
py-3
text-sm
focus:ring-2
focus:ring-blue-500
outline-none
"
        />

        <div
          className="
flex
gap-2
overflow-x-auto
"
        >
          {['all', 'assigned', 'pending'].map((item) => (
            <button
              key={item}
              onClick={() => setFilter(item)}
              className={`
px-4
py-2
rounded-full
text-xs
font-semibold
whitespace-nowrap capitalize

${filter === item ? 'bg-blue-600 text-white' : 'bg-slate-100 text-slate-600'}

`}
            >
              {item}
            </button>
          ))}
        </div>
      </div>

      {/* FIELD LIST */}

      <div
        className="
flex-1
overflow-y-auto
p-4
space-y-3
"
      >
        {filteredFields.map((field) => {
          const assigned = field.assignedUsers || [];

          const opened = openField === field.id;

          return (
            <div
              key={field.id}
              className={`
rounded-2xl
border
bg-white
transition
shadow-sm

${assigned.length ? 'border-green-200' : 'border-red-200'}

hover:shadow-lg

`}
            >
              {/* CARD */}

              <div
                className="
p-4
"
              >
                <div
                  className="
flex
justify-between
gap-3
"
                >
                  <div
                    className="flex-1 cursor-pointer"
                    onClick={() => onFieldClick(field)}
                  >
                    <div
                      className="
flex
items-center
gap-2
"
                    >
                      <h3
                        className="
font-semibold
text-sm
truncate capitalize
"
                      >
                        {field.label == 'dateField' ? 'Date' : field.label}
                      </h3>

                      <span
                        className="
text-[10px]
px-2
py-1
rounded-full
bg-purple-50
text-purple-600
"
                      >
                        Page {field.pageNumber || 1}
                      </span>
                    </div>

                    <div
                      className="
flex
gap-2
mt-2
"
                    >
                      {assigned.length ? (
                        <span
                          className="
px-2
py-1
rounded-lg
text-xs
bg-green-50
text-green-600
"
                        >
                          ✓ {assigned.length} Assigned
                        </span>
                      ) : (
                        <span
                          className="
px-2
py-1
rounded-lg
text-xs
bg-red-50
text-red-500
"
                        >
                          Needs assignment
                        </span>
                      )}
                    </div>
                  </div>

                  <button
                    onClick={() => setOpenField(opened ? null : field.id)}
                    className={`
    group
    flex
    items-center
    gap-2
    px-4
    py-2.5
    rounded-xl
    text-xs
    font-semibold
    transition-all
    duration-300
    shadow-sm
    hover:shadow-md
    hover:-translate-y-0.5

    ${
      opened
        ? `
        bg-slate-100
        text-slate-700
        hover:bg-slate-200
        `
        : `
        text-white
        bg-gradient-to-r
        from-blue-600
        to-indigo-600
        hover:from-blue-700
        hover:to-indigo-700
        `
    }
  `}
                  >
                    {opened ? (
                      <>
                        <span
                          className="
text-base
"
                        >
                          ×
                        </span>
                        Close
                      </>
                    ) : (
                      <>
                        <span
                          className="
text-base
"
                        >
                          ＋
                        </span>
                        Assign
                      </>
                    )}
                  </button>
                </div>

                {/* USERS */}

                {assigned.length > 0 && (
                  <div
                    className="
mt-4
flex
items-center
gap-3
"
                  >
                    <div
                      className="
flex
- space-x-3
"
                    >
                      {assigned.slice(0, 4).map((user) => (
                        <div
                          key={user.id}
                          className="
w-9
h-9
rounded-full
text-white
flex
items-center
justify-center
text-[10px]
border-2
border-white
"
                        >
                          <img
                            src="/avatar.svg"
                            alt="User Avatar"
                            className=""
                          />
                        </div>
                      ))}

                      {assigned.length > 4 && (
                        <div
                          className="
w-9
h-9
rounded-full
bg-slate-200
flex
items-center
justify-center
text-xs
"
                        >
                          +{assigned.length - 4}
                        </div>
                      )}
                    </div>

                    <p
                      className="
text-xs
text-slate-500
"
                    >
                      {assigned.map((u) => u.name).join(', ')}
                    </p>
                  </div>
                )}
              </div>

              {/* ASSIGN DRAWER */}

              {opened && (
                <div
                  className="
border-t
bg-slate-50
p-4
animate-in
slide-in-from-top
"
                >
                  <input
                    placeholder="Search users..."
                    value={userSearch}
                    onChange={(e) => setUserSearch(e.target.value)}
                    className="
w-full
rounded-xl
border
px-4
py-2
mb-3
"
                  />

                  <div
                    className="
max-h-60
overflow-y-auto
space-y-2
"
                  >
                    {users
                      .filter((u) =>
                        u.name.toLowerCase().includes(userSearch.toLowerCase()),
                      )
                      .map((user) => {
                        console.log('assifned', assigned);
                        console.log('users', users);
                        const selected = assigned.some(
                          (u) => u.user_id === user.user_id,
                        );
                        return (
                          <button
                            key={user.id}
                            onClick={() => assignUser(field.id, user)}
                            className={`
w-full
flex
items-center
gap-3
p-3
rounded-xl
transition

${selected ? 'bg-blue-100' : 'bg-white'}

`}
                          >
                            <div
                              className="
w-9
h-9
rounded-full
text-white
flex
items-center
justify-center
text-xs
"
                            >
                              <img
                                src="/avatar.svg"
                                alt="User Avatar"
                                className="h-10 w-10 rounded-full border"
                              />
                            </div>
                            <div className="flex-1 text-left">
                              <p className="text-sm font-semibold">
                                {user.name}
                              </p>

                              <p className="text-xs text-slate-500">
                                {user.role}
                              </p>
                            </div>
                            {selected && (
                              <div
                                className="
ml-auto
w-6
h-6
rounded-full
bg-blue-600
text-white
flex
items-center
justify-center
text-xs
shadow
"
                              >
                                ✓
                              </div>
                            )}{' '}
                          </button>
                        );
                      })}
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
function Stat({ title, value, color }) {
  const colors = {
    blue: 'bg-blue-50 text-blue-600',
    green: 'bg-green-50 text-green-600',
    red: 'bg-red-50 text-red-500',
  };

  return (
    <div
      className={`
rounded-xl
p-3
${colors[color]}
`}
    >
      <p className="text-xs opacity-70">{title}</p>

      <p className="font-bold text-lg">{value}</p>
    </div>
  );
}
